<template>
  <div class="updates">
    <ith-top-bar />
    <ith-banner :item="banner" />
    <ith-sad-top />
    <ith-submenu-new-updates />

    <div class="container updates-container">
      <div>
        <ith-grid-movies-platform />
      </div>
      <div class="updates-container-item">
        <div>
          <ith-table-releasing />
        </div>
        <div>
          <ith-table-latest-review />
        </div>

        <div style="margin-top: 50px" v-if="banner != []">
          <ith-sad-asside :items="bannersad" />
        </div>
      </div>
    </div>
    <ith-sad-bottom />

    <ith-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NewUpdates",
  metaInfo: {
    title:
      "Upcoming Movies and TV Shows Streaming Premiere Dates - OTT Watchlist",
    meta: [
      {
        name: "description",
        content:
          "Don't miss any moment of your favorite movies and favorite tv shows as we give you the latest streaming premier dates. Check our top upcoming movies list.",
      },
      {
        name: "keywords",
        content:
          "streaming dates, upcoming ott movies, ott updates, favorite movies, favorite tv shows, top upcoming movies",
      },
    ],
  },

  data: () => ({
    bannersad: [],

    banner: {
      title: "",
      text: "",
      image: "./img/banners/UPCOMING_IMAGE.png",
    },
  }),

  created() {
    this.$store.commit("DISABLED_MENU");
    this.$store.commit("EDIT_CRITERIA", "");
    this.getBanner();
  },
  watch: {
    banners() {
      if (this.banners) this.getBanner();
    },
  },
  computed: mapState(["user", "banners"]),
  methods: {
    getBanner() {
      if (this.banners)
        this.banners.forEach((el) => {
          if (el.page == "upcoming" && el.position == "right")
            this.bannersad.push(el);
        });
      this.bannersad.sort(function (a, b) {
        if (a.order < b.order) {
          return -1;
        }
        if (a.order > b.order) {
          return 1;
        }
        return 0;
      });
    },
  },
};
</script>

<style scoped>
.updates {
  background-color: #2c3848;
}
.updates-container {
  display: grid;
  grid-template-columns: 70% 28%;
  column-gap: 2%;
}
.updates-container-item > div {
  margin-top: 50px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}

@media (max-width: 960px) {
  .updates-container {
    grid-template-columns: 100%;
    column-gap: 2%;
  }
  .updates-container-item > div {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
